import { render, staticRenderFns } from "./MultiPaneLayout.vue?vue&type=template&id=4d28971a&scoped=true&"
import script from "./MultiPaneLayout.vue?vue&type=script&lang=js&"
export * from "./MultiPaneLayout.vue?vue&type=script&lang=js&"
import style0 from "./MultiPaneLayout.vue?vue&type=style&index=0&id=4d28971a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d28971a",
  null
  
)

component.options.__file = "MultiPaneLayout.vue"
export default component.exports